'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.operation = void 0;
var tslib_1 = require('tslib');
var typed_redux_saga_1 = require('typed-redux-saga');
var createActions_1 = require('../utils/createActions');
var inheritDescriptor_1 = require('./inheritDescriptor');
function isStringId(id) {
    return typeof id === 'string';
}
function createDescriptor(options) {
    var target = options.target,
        key = options.key,
        descriptor = options.descriptor,
        operationOptions = options.operationOptions;
    var _a = operationOptions || {},
        updateStrategy = _a.updateStrategy,
        id = _a.id,
        ssr = _a.ssr;
    var origin = descriptor.value;
    var operationId = id || (0, createActions_1.createActionType)(target.toString(), key);
    descriptor.value.destroy = {};
    if (isStringId(operationId)) {
        // WARNING: внешняя операция скроет под собой внутренние
        origin.id = operationId;
    }
    function operationWrapper() {
        var _i, id, uniqId, operation;
        var args = [];
        for (_i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (0, tslib_1.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(this === null || this === void 0 ? void 0 : this._operationsService)) {
                        throw new Error('Custom services have to be inherited from "Service" class');
                    }
                    id = isStringId(operationId)
                        ? operationId
                        : operationId.apply(void 0, (0, tslib_1.__spreadArray)([], (0, tslib_1.__read)(args), false));
                    uniqId = id;
                    operation = this._operationsService.createOperation({
                        operationArgs: [uniqId, origin, updateStrategy],
                        ssr: !!ssr,
                    });
                    return [
                        5 /*yield**/,
                        (0, tslib_1.__values)(
                            (0, typed_redux_saga_1.call)(this._operationsService.registerConsumer, this, uniqId)
                        ),
                    ];
                case 1:
                    _a.sent();
                    return [
                        5 /*yield**/,
                        (0, tslib_1.__values)(
                            typed_redux_saga_1.call.apply(
                                void 0,
                                (0, tslib_1.__spreadArray)([[this, operation.run]], (0, tslib_1.__read)(args), false)
                            )
                        ),
                    ];
                case 2:
                    return [2 /*return*/, _a.sent()];
            }
        });
    }
    return (0, inheritDescriptor_1.inheritDescriptor)(descriptor, operationWrapper);
}
function operation() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (args.length === 1) {
        var operationOptions_1 = ['object'].includes(typeof args[0])
            ? args[0]
            : ['function', 'string'].includes(typeof args[0])
            ? { id: args[0] }
            : null;
        if (!operationOptions_1) {
            throw new Error('Unexpected arguments');
        }
        return function operationDesc(target, key, descriptor) {
            return createDescriptor({
                target: target,
                key: key,
                descriptor: descriptor,
                operationOptions: operationOptions_1,
            });
        };
    }
    var _a = (0, tslib_1.__read)(args, 3),
        target = _a[0],
        key = _a[1],
        descriptor = _a[2];
    return createDescriptor({ target: target, key: key, descriptor: descriptor });
}
exports.operation = operation;
